import gateway from '@/_gateway.config.js'
import { APPID, ACTIVITYCODE } from '@/config'

export function logout () {
  let currUrl = encodeURIComponent(location.href)
  return `${gateway.ssoUrl}/logout?redirect_uri=${currUrl}`
}

export default function (path) {
  // h5登录页
  // let currUrl = encodeURIComponent(location.href)
  // return `${gateway.ssoUrl}/h5logincenter?appid=${APPID}&activityCode=${ACTIVITYCODE}&redirect_uri=${currUrl}&channelKeyword=`

  // 微信授权静默登录
  let host = process.env.VUE_APP_ENV === 'production' ? 'http://weixin.vipkid.com.cn' : 'http://stage-weixin.vipkid-qa.com.cn'
  let redirecUrl = encodeURIComponent(`${host}/wx/multi/oauth/validateBind`)
  let state = encodeURIComponent(`/#${path}?ac=${ACTIVITYCODE}&appId=${APPID}`)
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${redirecUrl}&response_type=code&scope=snsapi_base&state=${state}#wechat_redirect`
}

export const redirectUserInfo = function () {
  // 微信授权静默登录
  let redirecUrl = encodeURIComponent(window.location.href)
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${APPID}&redirect_uri=${redirecUrl}&response_type=code&scope=snsapi_userinfo&state=#wechat_redirect`
}
